import { Component } from "react";


class SocieteFactureBox extends Component {
  render() {
    return (
      <div className="col-sm-3 invoice-col">
        {this.props.role}
        <address>
          <strong>{this.props.societe?.title}</strong>
          <br />
          {this.props.societe?.adresse}
          <br />
        </address>
      </div>
    );
  }
}
export default SocieteFactureBox;
